import { ASSISTANT_PLAN_PROSE_CLASS } from "@/components/assistant/assistantPlanProse";
import type { WriteApprovalPlanFieldCard as FieldCardModel } from "@/components/assistant/formatWriteApprovalSummary";
import { AssistantMarkdownContent } from "@/components/chat/AssistantMarkdownContent";
import { cn } from "@/lib/utils";

type Props = {
  field: FieldCardModel;
};

export function AssistantPlanFieldCard({ field }: Props) {
  const { label, value, format = "plain", span = "half" } = field;
  const display = value.trim();

  return (
    <div
      className={cn(
        "rounded-xl border border-[rgba(15,23,42,0.09)] bg-white/60 px-3 py-2.5 dark:border-white/10 dark:bg-white/[0.04]",
        span === "full" && "col-span-1 sm:col-span-2"
      )}
    >
      <p className="text-[11px] font-medium uppercase tracking-wide text-[var(--lm-muted)] dark:text-slate-400">
        {label}
      </p>
      <div className="mt-1.5 min-w-0">
        {!display ? (
          <p className="text-sm text-[#576274] dark:text-gray-400">—</p>
        ) : format === "markdown" ? (
          <AssistantMarkdownContent content={display} className={ASSISTANT_PLAN_PROSE_CLASS} />
        ) : format === "code" ? (
          <pre className="max-h-48 overflow-auto whitespace-pre-wrap break-words rounded-lg bg-[rgba(15,23,42,0.04)] p-2 font-mono text-xs leading-relaxed text-[#101828] dark:bg-white/5 dark:text-slate-200">
            {display}
          </pre>
        ) : (
          <p className="break-words text-sm leading-relaxed text-[#101828] dark:text-white">{display}</p>
        )}
      </div>
    </div>
  );
}
